module.exports = __webpack_public_path__ + "static/media/70.ac09913c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/70.jpg
// module id = 629
// module chunks = 0